import React from "react";
import { Toast } from "react-bootstrap";
import { Icons } from "../Icons";
import "./toast.scss";

export const Toasts = ({
  showToast,
  toastContent,
  setShowToaster,
  floatEnd,
}) => {
  return (
    <Toast
      bg="success"
      onClose={() => {
        sessionStorage.removeItem("showToaster");
        setShowToaster(false);
      }}
      show={showToast}
      className={floatEnd}
    >
      <Toast.Body>
        <Icons
          variant="icon-twenty-four-px "
          iconname="form-fields-success-tick"
        />
        <span>{toastContent}</span>
        <Icons
          variant="icon-twenty-four-px "
          iconname="close"
          clickHandler={() => {
            sessionStorage.removeItem("showToaster");
            setShowToaster(false);
          }}
        />
      </Toast.Body>
    </Toast>
  );
};
